var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.retentionGraphData)?_c('div',{staticClass:"barChart"},[_c('highcharts',{ref:"lineGraph",staticClass:"eventsChart",attrs:{"options":_vm.retentionGraphData}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }